"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
const core_1 = require("../core");
class Notifications extends core_1.CrowdinApi {
    /**
     * @param request request body
     * @see https://developer.crowdin.com/api/v2/#operation/api.notify.post
     */
    sendNotificationToAuthenticatedUser(request) {
        const url = `${this.url}/notify`;
        return this.post(url, request, this.defaultConfig());
    }
    /**
     * @param projectId project identifier
     * @param request request body
     * @see https://developer.crowdin.com/api/v2/#operation/api.projects.notify.post
     */
    sendNotificationToProjectMembers(projectId, request) {
        const url = `${this.url}/projects/${projectId}/notify`;
        return this.post(url, request, this.defaultConfig());
    }
    /**
     * @param request request body
     * @see https://developer.crowdin.com/enterprise/api/v2/#operation/api.notify.post
     */
    sendNotificationToOrganizationMembers(request) {
        const url = `${this.url}/notify`;
        return this.post(url, request, this.defaultConfig());
    }
}
exports.Notifications = Notifications;
